import React, { useEffect, useState } from 'react';
import Chart from 'chart.js/auto';
import { guid, makeArray } from '../../../utils';
import { get, first } from '../../../lib/lodash';
import { avgItems } from '../utils';
import useStyles from '../styles';
import clsx from 'clsx';
import { DropDown } from '../../dropdown';
import { ListItemIcon } from '@material-ui/core';

const COLORS = [
  '#D34216ff',
  '#0043D9ff',
  '#60d394ff',
  '#fdcb47ff',
  '#c76b98ff',
  '#b01400ff',
  '#4eb3ffff',
  '#20751cff',
  '#cc7b00ff',
  '#c12dc1ff',
  '#ee8d5cff',
  '#001682ff',
  '#3fbe5aff',
  '#fda102ff',
  '#dda6afff',

  '#D34216ff',
  '#0043D9ff',
  '#60d394ff',
  '#fdcb47ff',
  '#c76b98ff',
  '#b01400ff',
  '#4eb3ffff',
  '#20751cff',
  '#cc7b00ff',
  '#c12dc1ff',
  '#ee8d5cff',
  '#001682ff',
  '#3fbe5aff',
  '#fda102ff',
  '#dda6afff',

  '#D34216ff',
  '#0043D9ff',
  '#60d394ff',
  '#fdcb47ff',
  '#c76b98ff',
  '#b01400ff',
  '#4eb3ffff',
  '#20751cff',
  '#cc7b00ff',
  '#c12dc1ff',
  '#ee8d5cff',
  '#001682ff',
  '#3fbe5aff',
  '#fda102ff',
  '#dda6afff',
]

const makeDisplayNumber = (v = '') => {
  return parseFloat(`${v || ''}`.split('%').join(''));
}

export const DataChart = props => {
  const {
    data,
    hasData,
    chart,
    loading,
    isDate,
    getDisplayVal,
    getHeaderTitle,
    showCounts,
    hasRange
  } = props;

  const classes = useStyles();

  const [state, setState] = useState({ 
    id: guid(),
    tables: makeArray(20),
    force: 0,
  })

  const getCanvasId = (i) => {
    return `chart_${state.id}_${i}`;
  }

  const hasChartIndex = props.chartIndex !== undefined;

  useEffect(() => {
    let charts = [];

    if (hasData && !loading && !chart.error) {
      chart.tables.map((t, i) => {
        if (hasChartIndex && i !== props.chartIndex) { return charts.push(null) }
        
        const ctx = document.getElementById(getCanvasId(i));

        const col = chart.cols[i];

        const config = {
          type: isDate ? 'line' : 'bar',
          data: {
            labels: chart.header.map(h => {
              const ht = getHeaderTitle({ ...props, val: h });
              return get(ht, 'name', ht);
            }),
            datasets: ['avg', ...t.rows].map((tr, tri) => {
              if (tr === 'avg') {
                return {
                  grouped: true,
                  label: 'Average',
                  data: col.map(c => Math.max(makeDisplayNumber(getDisplayVal({ val: { ...first(c), value: avgItems(c) }}).display), 0)),
                  backgroundColor: COLORS[tri],
                  borderColor: COLORS[tri],
                  hidden: false,
                  spanGaps: true
                }
              } else {
                const [label, ...rows] = tr;
                return {
                  grouped: true,
                  label: label.value,
                  data: rows.map(cc => makeDisplayNumber(getDisplayVal({ val: { ...cc } }).display)),
                  backgroundColor: COLORS[tri],
                  borderColor: COLORS[tri],
                  hidden: isDate ? false : true,
                  spanGaps: true
                }
              }
            }),
          },
          options: {
            scales: {
              y: {
                beginAtZero: hasRange ? false : true
              }
            },
            plugins: {
              legend: {
                display: false,
                // onClick: legendClickHandler,
              }
            }
          }
        };
  
        charts.push(new Chart(ctx, config));
      })
    }

    setState(s => ({ ...s, charts }));

    return () => {
      charts.map(c => c && c.destroy && c.destroy());
    }
  }, [chart, hasData, data, loading, showCounts])

  const changeLabel = (e, ch) => {
    const vals = e.target.value;

    ch.legend.legendItems.map((li, i) => {
      const meta = ch.getDatasetMeta(i);
      meta.hidden = !vals.includes(meta.label)
    })
    ch.update();
    setState(s => ({ ...s, force: s.force + 1 }));
  }

  const renderValue = (val) => {
    return val.join(', ');
  }

  const isSingleChart = !hasChartIndex;

  return (
    <div className={hasChartIndex ? '' : classes.chartWrap}>
      {state.tables.map((t, i) => {
        const exists = hasChartIndex ? i === props.chartIndex : get(chart, `tables.${i}`);
        const ch = get(state, `charts.${i}`);
        return (
          <div key={i} className={clsx(isSingleChart && classes.chartWrapEach, classes.container, hasChartIndex && classes.removeBox)} style={!!exists ? { } : { display: 'none' }}>
            {!!exists && !hasChartIndex && props.renderBar(exists, i, { includeTitle: true })}
            <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '98%', paddingBottom:'1em' }}>
              <DropDown 
                label="Series"
                renderValue={renderValue}
                value={get(ch, 'legend.legendItems', []).filter(t => !t.hidden).map(t => t.text)} 
                multiple 
                options={get(ch, 'legend.legendItems', []).map(t => ({ 
                  id: t.text, 
                  name: (
                    <>
                      <ListItemIcon>
                        <div style={{ width: 20, height: 20, backgroundColor: t.fillStyle }} />
                      </ListItemIcon>
                      <span>{t.text}</span>
                    </>
                  )
                }))} 
                onChange={e => changeLabel(e, ch)} 
              />
            </div>
            <canvas id={getCanvasId(i)} />
          </div>
        )
      })}
    </div>
  )
}